import React from 'react';
import styles from './PFSWhoWeServe.module.css';
import globalStyles from '../../styles/global.module.css';
import ContentContainer from '../ContentContainer/ContentContainer';
import PFSContactCta from '../PFSContactCta/PFSContactCta';
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRocket,
  faCar,
  faHardHat,
  faCartShopping,
  faGraduationCap,
  faFilm,
  faHandshake,
  faHeartPulse,
  faUsers,
  faUmbrella,
  faLeaf,
  faGavel,
  faTruck,
  faIndustry,
  faBullhorn,
  faHandHoldingHeart,
  faChartLine,
  faBriefcase,
  faHouse,
  faStore,
  faMicrochip,
  faBoxes,
} from '@fortawesome/free-solid-svg-icons';

const industries = [
  { name: 'Aerospace', icon: faRocket, link: null },
  { name: 'Automotive', icon: faCar, link: null },
  { name: 'Construction', icon: faHardHat, link: null },
  { name: 'E-Commerce', icon: faCartShopping, link: null },
  { name: 'Education', icon: faGraduationCap, link: null },
  { name: 'Entertainment', icon: faFilm, link: null },
  { name: 'General Service and Consulting', icon: faHandshake, link: null },
  { name: 'Healthcare and Fitness', icon: faHeartPulse, link: null },
  { name: 'Individuals, Trusts, and Estates', icon: faUsers, link: null },
  { name: 'Insurance', icon: faUmbrella, link: 'https://insurance.pfsonline.com/' },
  { name: 'Landscaping and Agriculture', icon: faLeaf, link: null },
  { name: 'Law Firms', icon: faGavel, link: 'https://law.pfsonline.com/' },
  { name: 'Logistics, Transportation, and Warehousing', icon: faTruck, link: null },
  { name: 'Manufacturing', icon: faIndustry, link: null },
  { name: 'Marketing and Events', icon: faBullhorn, link: null },
  { name: 'Nonprofit', icon: faHandHoldingHeart, link: 'https://nonprofit.pfsonline.com/' },
  { name: 'Private Equity and Holding Companies', icon: faChartLine, link: null },
  { name: 'Professional Service', icon: faBriefcase, link: null },
  { name: 'Real Estate', icon: faHouse, link: null },
  { name: 'Retail, Restaurant, and Hospitality', icon: faStore, link: null },
  { name: 'Technology', icon: faMicrochip, link: null },
  { name: 'Wholesale and Distribution', icon: faBoxes, link: null },
];

const PFSWhoWeServe = () => {
  useBreadcrumb([{ label: 'Who We Serve', url: '/who-we-serve' }]);

  return (
    <div className={styles.PFSWhoWeServe} data-testid='PFSWhoWeServe'>
      <center>
        <p className={globalStyles.TitleText}>Who We Serve</p>
      </center>
      <ContentContainer>
        <center className={styles.IntroText}>
          <p>
            PFS Global serves a diverse range of industries across the
            financial, operational, and technology spectrum. Browse the full
            list of industries we work with below.
          </p>
          <br />
        </center>
      </ContentContainer>
      <ContentContainer>
        <div className={styles.industriesGrid}>
          {industries.map((industry, index) => {
            const cardContent = (
              <>
                <div className={styles.industryIcon}>
                  <FontAwesomeIcon icon={industry.icon} />
                </div>
                <h3 className={styles.industryName}>{industry.name}</h3>
                <span className={styles.industryCta}>
                  {industry.link ? 'Learn More →' : 'Contact Us →'}
                </span>
              </>
            );

            return industry.link ? (
              <a
                key={index}
                href={industry.link}
                target='_blank'
                rel='noopener noreferrer'
                className={styles.industryCard}
              >
                {cardContent}
              </a>
            ) : (
              <NavLink
                key={index}
                to='/contact'
                className={styles.industryCard}
              >
                {cardContent}
              </NavLink>
            );
          })}
        </div>
      </ContentContainer>
      <PFSContactCta
        ctaText='Free Consultation!'
        metaText='Call us today to receive your'
      />
    </div>
  );
};

PFSWhoWeServe.propTypes = {};

export default PFSWhoWeServe;